import { request } from "umi";

/** hm -- 首页装修 -- 查询最近的一次启用状态的首页配置【B端】
 * GET /hm/home_page/get
 * 接口ID：45995507
 * 接口地址：https://app.apifox.com/link/project/1822157/apis/api-45995507
 */
export async function fetchLatestHomepageConfig() {
  return request('/hm/home_page/get');
}

/** hm -- 首页装修 -- 新增/修改 首页【B端】
 * POST /hm/home_page/save
 * 接口ID：45995508
 * 接口地址：https://app.apifox.com/link/project/1822157/apis/api-45995508
 */
export async function saveHomepageConfig(data: Record<string, any>) {
  return request('/hm/home_page/save', {
    method: 'POST',
    data
  });
}
